import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import ContentHeader from "../../components/molecules/ContentHeader";
import styled from "styled-components";
import useGoogleMapsApi from "../../../../services/useGoogleMapsApi";
import { CardLogBootstrapStyled } from "../../../../styledComponents/CardBootstrapLog";
import { Input } from "rsuite";
import LogButton from "../../../../components/atoms/LogButton";
import {
  getLastTrackingParentDador,
  getLastTrackingTomador,
} from "../../../../api/modules";
import { errorToast } from "../../../../services/toastService";
import { useSelector } from "react-redux";
import ReactDOM from "react-dom";
import MapOverlay from "../../components/molecules/MapOverlay";
import { useHistory } from "react-router-dom";
import { DADOR_DE_CARGA } from "../../../../constants/UserType";
import truckIcon from "../../../../assets/img/Camion.png";

const MapContainer = styled.div`
  width: 100%;
  height: 600px;
  border-radius: 0px;
`;

function FleetLocation() {
  const mapRef = useRef(null);
  const googleMapsApi = useGoogleMapsApi();
  const history = useHistory();
  const { user } = useSelector((state) => state.authApp);
  const spinner = useSelector((state) => state.appReducer.isLoading);
  const isParentAccount = Boolean(user?.is_parent_account);

  const [locations, setLocations] = useState([]);
  const [filteredDomainOrId, setFilteredDomainOrId] = useState("");

  const activeOverlayRef = useRef(null);
  const currentDirectionsRendererRef = useRef(null);
  const routeCacheRef = useRef(new Map());

  const fetchLocations = async () => {
    const { msg, lastTracking } = isParentAccount
      ? await getLastTrackingParentDador()
      : await getLastTrackingTomador();
    if (msg) {
      errorToast(msg);
      setLocations([]);
    } else {
      setLocations(lastTracking);
    }
  };

  const handleSearchChange = (value) => {
    setFilteredDomainOrId(value);
  };

  const overlayDetails = (url) => {
    if (isParentAccount) return;
    history.push(url);
  };

  const handleRefresh = () => {
    fetchLocations();
    setFilteredDomainOrId("");
  };

  const clearActiveOverlay = (state) => {
    if (activeOverlayRef.current && !state) {
      activeOverlayRef.current.setMap(null);
      activeOverlayRef.current = null;
    }
    if (currentDirectionsRendererRef.current) {
      currentDirectionsRendererRef.current.setMap(null);
      currentDirectionsRendererRef.current = null;
    }
  };

  const handleLoadGoogleMap = () => {
    const map = new googleMapsApi.Map(mapRef.current, {
      zoom: 5,
      center: { lat: -38.4192641, lng: -63.5989206 },
    });

    const filteredLocations = filteredDomainOrId
      ? locations.filter(
          (l) =>
            (l.domain || "")
              .toLowerCase()
              .includes(filteredDomainOrId.toLowerCase()) ||
            (l.dador_info?.email || "")
              .toLowerCase()
              .includes(filteredDomainOrId.toLowerCase()) ||
            (`${l.dador_info?.name || ""} ${l.dador_info?.last_name || ""}`)
              .toLowerCase()
              .includes(filteredDomainOrId.toLowerCase()) ||
            (l.parent_id + l.order)
              .toLowerCase()
              .includes(filteredDomainOrId.toLowerCase())
        )
      : locations;

    if (filteredLocations.length === 0) return;

    const bounds = new googleMapsApi.LatLngBounds();

    filteredLocations.forEach((vehicle) => {
      const position = new googleMapsApi.LatLng(vehicle.lat, vehicle.lng);

      const marker = new googleMapsApi.Marker({
        position,
        map,
        title: vehicle.domain,
        icon: {
          url: truckIcon,
          scaledSize: new googleMapsApi.Size(32, 32),
          anchor: new googleMapsApi.Point(16, 32),
        },
      });

      const overlayDiv = document.createElement("div");
      overlayDiv.style.position = "absolute";

      const overlay = new googleMapsApi.OverlayView();

      overlay.onAdd = function () {
        this.getPanes().overlayMouseTarget.appendChild(overlayDiv);
      };

      overlay.draw = function () {
        const projection = this.getProjection();
        const point = projection.fromLatLngToDivPixel(position);
        overlayDiv.style.left = point.x + "px";
        overlayDiv.style.top = point.y - 40 + "px";
      };

      overlay.onRemove = function () {
        ReactDOM.unmountComponentAtNode(overlayDiv);
        overlayDiv.parentNode && overlayDiv.parentNode.removeChild(overlayDiv);
      };

      marker.addListener("click", () => {
        clearActiveOverlay();

        ReactDOM.render(
          <MapOverlay
            onClose={() => clearActiveOverlay()}
            hideRoute={() => clearActiveOverlay(true)}
            showRoute={() => {
              const vehicleId = vehicle._id;

              if (routeCacheRef.current.has(vehicleId)) {
                const cachedDirections = routeCacheRef.current.get(vehicleId);
                const renderer = new googleMapsApi.DirectionsRenderer({
                  map,
                  /* preserveViewport: true, */
                  /* suppressMarkers: false, */
                });
                renderer.setDirections(cachedDirections);
                currentDirectionsRendererRef.current = renderer;
                return;
              }

              const originLatLng = new googleMapsApi.LatLng(
                vehicle.origin_site_coords.latitude,
                vehicle.origin_site_coords.longitude
              );
              const destinationLatLng = new googleMapsApi.LatLng(
                vehicle.destiny_site_coords.latitude,
                vehicle.destiny_site_coords.longitude
              );

              const directionsService = new googleMapsApi.DirectionsService();
              const directionsRenderer = new googleMapsApi.DirectionsRenderer({
                map,
                /* preserveViewport: true, */
                /* suppressMarkers: false, */
              });

              directionsService
                .route({
                  origin: originLatLng,
                  destination: destinationLatLng,
                  travelMode: googleMapsApi.TravelMode.DRIVING,
                })
                .then((result) => {
                  routeCacheRef.current.set(vehicleId, result);
                  directionsRenderer.setDirections(result);
                  currentDirectionsRendererRef.current = directionsRenderer;
                })
                .catch((e) => {
                  console.error("Error al obtener ruta: ", e);
                });
            }}
            showId={vehicle.parent_id + vehicle.order}
            detailId={vehicle._id}
            tripId={vehicle.id_trip}
            {...vehicle}
            role={user.role_id?.name}
            isParentAccount={isParentAccount}
            origin={vehicle.origin_site}
            destiny={vehicle.destiny_site}
            details={overlayDetails}
          />,
          overlayDiv
        );
        overlay.setMap(map);
        activeOverlayRef.current = overlay;
        map.setCenter(marker.getPosition());
        map.panBy(0, -50);
      });

      bounds.extend(marker.getPosition());
    });

    map.fitBounds(bounds);
  };

  useEffect(() => {
    if (googleMapsApi) {
      handleLoadGoogleMap();
    }
  }, [googleMapsApi, locations, filteredDomainOrId]);

  useEffect(() => {
    fetchLocations();
  }, []);

  return (
    <Container fluid>
      <ContentHeader
        title={
          isParentAccount
            ? "Ubicación de cargas agrupadas"
            : user.role_id?.name === DADOR_DE_CARGA
            ? "Ubicación de tu carga"
            : "Ubicación de flota"
        }
      />
      <CardLogBootstrapStyled
        className="shadow-6dp p-4 my-3"
        style={{ backgroundColor: "rgba(157, 197, 55, 0.2)" }}
      >
        <Row className="my-2">
          <Col md={6}>
            {spinner ? (
              <p className="mb-0">Cargando ubicaciones...</p>
            ) : locations.length > 0 ? (
                <Input
                placeholder={
                  isParentAccount
                    ? "Buscar por cuenta, dominio o ID..."
                    : "Buscar por dominio o ID..."
                }
                value={filteredDomainOrId}
                onChange={handleSearchChange}
              />
            ) : (
              <p className="mb-0">No hay vehículos activos en este momento.</p>
            )}
          </Col>
          <Col md={2} className="mt-2 mt-md-0">
            <LogButton title={"Refrescar"} onClick={handleRefresh} />
          </Col>
        </Row>
      </CardLogBootstrapStyled>

      <Card
        className="shadow-6dp mt-4"
        style={{ borderRadius: "0px", border: "none" }}
      >
        <Card.Body className="p-0">
          <MapContainer>
            <div id="map" ref={mapRef}></div>
          </MapContainer>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default FleetLocation;
